export default defineNuxtPlugin((nuxtApp) => {
    if (process.client) {
        (function() {
            var _paq = window._paq = window._paq || []
            _paq.push(['trackPageView'])
            _paq.push(['enableLinkTracking'])
            _paq.push(['setTrackerUrl', '//tracking.ejwonline.de/matomo.php'])
            _paq.push(['setSiteId', '34'])
            var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0]
            g.async=true; g.src='//tracking.ejwonline.de/matomo.js'; s.parentNode.insertBefore(g,s)
        })()
    }
})